import { render, staticRenderFns } from "./ProfileWallet.vue?vue&type=template&id=cfe9ab36&scoped=true"
import script from "./ProfileWallet.vue?vue&type=script&lang=ts"
export * from "./ProfileWallet.vue?vue&type=script&lang=ts"
import style0 from "./ProfileWallet.vue?vue&type=style&index=0&id=cfe9ab36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfe9ab36",
  null
  
)

export default component.exports